import axios, { AxiosResponse } from 'axios'
import { DecisaoTriagemRequest, TriagemHistorico } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const TRIAGEM_URL = `${API_URL}/triagens`

/** Histórico de triagens do atendimento (regras, sinais, variáveis e decisões). */
export const getTriagemHistorico = (idAtendimento: number): Promise<TriagemHistorico> =>
  axios
    .get(`${TRIAGEM_URL}/atendimento/${idAtendimento}`)
    .then((response: AxiosResponse<TriagemHistorico>) => response.data)

/**
 * Confirma ou altera a cor da triagem vigente. A resposta já é o histórico atualizado — o card
 * troca o cache com ela em vez de disparar um GET novo.
 */
export const registrarDecisaoTriagem = (
  idTriagem: number,
  decisao: DecisaoTriagemRequest
): Promise<TriagemHistorico> =>
  axios
    .post(`${TRIAGEM_URL}/${idTriagem}/decisao`, decisao)
    .then((response: AxiosResponse<TriagemHistorico>) => response.data)
